<template>
  <div>
    <div class="box mb20">
      <el-page-header
        @back="$router.go(-1)"
        :content="$t('tCouponUseList')"
      ></el-page-header>
    </div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t("search_zh")
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t("btnTip.reset")
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <div></div>
        <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:user_gender="slotProps">
          <div>{{ user_gender(slotProps.callback.row.user_gender) }}</div>
        </template>
        <!-- <template v-slot:operation="slotProps">
            <el-tooltip class="item" effect="dark" :content="$t('btnTip').check" placement="top">
             <el-button
              @click="handleClick('check',slotProps.callback.row)"
              icon="el-icon-view"
              type="success"
              size="mini"
            ></el-button>
          </el-tooltip>
           <el-tooltip class="item" effect="dark" :content="$t('btnTip').edit" placement="top">
            <el-button
              @click="handleClick('edit',slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t("btnTip").delete }}</el-button
            >
          </el-tooltip>
        </template> -->
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { couponUseList } from "@/api/api";
export default {
  name: "couponUseList",
  mixins: [mixin_list(couponUseList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
        coupon: this.$route.query.id,
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
        {
          label: this.$t("couponList.create_time"),
          sortable: true,
          prop: "create_time",
        },
        {
          label: this.$t("couponList.use_time"),
          sortable: true,
          prop: "use_time",
        },
        {
          label: this.$t("couponList.user_name"),
          sortable: true,
          prop: "user_name",
        },
        {
          label: this.$t("couponList.real_name"),
          sortable: true,
          prop: "real_name",
        },
        {
          label: this.$t("couponList.user_phone"),
          sortable: true,
          prop: "user_phone",
        },
        {
          label: this.$t("couponList.user_gender"),
          sortable: true,
          prop: "user_gender",
          slot: "user_gender",
        },
        {
          label: this.$t("couponList.service_info"),
          sortable: true,
          prop: "service_info",
        },
        // {
        //   label: this.$t("operation"),
        //   prop: "",
        //   width: 300,
        //   slot: "operation",
        // },
      ],
    };
  },
  methods: {
    user_gender(user_gender) {
      switch (user_gender) {
        case 0:
          return this.$t("couponList.user_gender0");
        case 1:
          return this.$t("couponList.user_gender1");
        case 2:
          return this.$t("couponList.user_gender2");
      }
    },
    // async handleClick(type, data) {
    //   switch (type) {
    //     case "add":
    //       this.$router.push('/activityManagement/activityList/edit')
    //       break;
    //     case "edit":
    //       this.$router.push(`/activityManagement/activityList/edit?id=${data.id}`)
    //       break;
    //     case "check":
    //       this.$router.push(`/activityManagement/activityList/detail?id=${data.id}`)
    //       break;
    //   }
    // },
    // async del(id) {
    //   this.$confirm(this.$t('activityList').sureDeleteActivity, this.$t('tips'), {
    //     confirmButtonText: this.$t('btnTips').submit,
    //     cancelButtonText: this.$t('btnTips').cancel,
    //     type: 'warning'
    //   }).then(async () => {
    //     let res = await deleteActivity(id)
    //     this.get_list()
    //   }).catch({
    //   })
    // },
  },
};
</script>
